import React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="add circle active-layer"
    viewBox="0 0 18 18"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M2.21 4.49h2.36v1.03H2.21zM13.23 4.49h2.32v1.03h-2.32zM3.51 1.946l.73-.728 1.81 1.81-.729.728zM9.53 2.539L9.929.01l1.018.16-.398 2.529zM6.844.156l1.017-.16.398 2.53-1.018.16zM11.723 3.023l1.81-1.81.729.728-1.81 1.81zM14.64 9.66l-2.52-.84V5.73a1.83 1.83 0 0 0-1.75-1.91h-.08a1.82 1.82 0 0 0-1.37.63 1.82 1.82 0 0 0-1.37-.63 1.89 1.89 0 0 0-.37 0 1.89 1.89 0 0 0-1.46 1.91V11l-.38-.38a1.83 1.83 0 0 0-2.59 2.58l3.73 3.73A3.66 3.66 0 0 0 9.06 18h4a2.74 2.74 0 0 0 2.74-2.74v-3.9a1.83 1.83 0 0 0-1.16-1.7zm0 5.6A1.65 1.65 0 0 1 13 16.91H9a2.55 2.55 0 0 1-1.78-.76l-3.7-3.73a.73.73 0 0 1 1-1l.38.38 1.91 1.85V5.73a.8.8 0 0 1 .58-.8h.16a.72.72 0 0 1 .55.26l.28.32v3.91h1.1V5.49l.28-.32a.72.72 0 0 1 .55-.26h.16a.8.8 0 0 1 .58.8v3.9l.75.25 2.48.83a.73.73 0 0 1 .43.67z" />
  </svg>
);

export default SvgComponent;
